// Catálogos CERRADOS del perfil enriquecido opt-in (ítem 8 de ops/BACKLOG.md,
// OK del fundador 2026-08-28: "los tres").
//
// Por qué existe: la segmentación de los análisis (y del informe nacional) se
// cortaba porque el perfil no sabía de qué universidad eres ni dónde trabajas;
// el corte por dominio de correo ve 1 de cada 5 (80% usa correo personal).
// Estos dos campos son OPCIONALES de verdad: se pueden dejar en blanco, nada
// los exige y la UI no insiste (anti-culpa). El tercer campo del ítem, el año
// de carrera, YA existía en profiles.anio_carrera (entero 1 a 7, migración
// 20260427000000) y ya se pregunta a estudiantes en ambas superficies; no se
// duplica (máxima coherencia: mismo concepto, mismo campo).
//
// Regla dura, misma que origen_conocido: catálogo cerrado, JAMÁS texto libre
// (PII-safe por construcción). "Otra" existe justamente para no necesitar un
// campo abierto. Desde el 2026-10-04 (A17, respuesta del fundador) la
// universidad del estudiante es SOLO esta lista: el texto libre
// profiles.institucion ya no se le pregunta (ver aplicaInstitucion) y queda
// para el hospital o clínica de quien ejerce. NULL = no respondió.
//
// Espejo en la BD: el CHECK de supabase/migrations/20260901000001_profiles_perfil_enriquecido.sql
// lleva la MISMA allowlist literal (fijado por test, que lee el .sql). Para
// agregar un valor: aquí + migración que solo AMPLÍE el CHECK (patrón de
// "congreso" en origen_conocido).

// Universidad: derivada de los dominios institucionales DEMOSTRABLES del
// análisis ops/analisis/2026-08-28-bateria1-universidades-canales-embudo.md
// (los 13 dominios con n>=3). Las deducciones de la cola larga NO entran hasta
// verificarse; mientras tanto caen en "otra" y el conteo de "otra" dice cuándo
// ampliar. Orden alfabético por etiqueta (es un select: se busca por nombre,
// no por tamaño de cohorte); "otra" siempre al final.
export const UNIVERSIDAD_OPTIONS = [
  { value: 'uisek',   label: 'UISEK' },
  { value: 'uda',     label: 'U. de Atacama' },
  { value: 'uchile',  label: 'U. de Chile' },
  { value: 'ufro',    label: 'U. de La Frontera (UFRO)' },
  { value: 'userena', label: 'U. de La Serena' },
  { value: 'uoh',     label: "U. de O'Higgins (UOH)" },
  { value: 'upla',    label: 'U. de Playa Ancha (UPLA)' },
  { value: 'uta',     label: 'U. de Tarapacá (UTA)' },
  { value: 'ucn',     label: 'U. Católica del Norte (UCN)' },
  { value: 'udp',     label: 'U. Diego Portales (UDP)' },
  { value: 'uft',     label: 'U. Finis Terrae' },
  { value: 'umayor',  label: 'U. Mayor' },
  { value: 'uss',     label: 'U. San Sebastián (USS)' },
  { value: 'otra',    label: 'Otra universidad' },
];

// Servicio: catálogo corto dictado en el backlog (UCI/UTI, urgencia,
// médico-quirúrgico, pabellón, APS, neonatología/pediatría, otro). Para quien
// ejerce es "dónde trabajas"; para el estudiante, "dónde haces práctica hoy".
export const SERVICIO_OPTIONS = [
  { value: 'uci_uti',                label: 'UCI / UTI' },
  { value: 'urgencia',               label: 'Urgencia' },
  { value: 'medico_quirurgico',      label: 'Médico-quirúrgico' },
  { value: 'pabellon',               label: 'Pabellón' },
  { value: 'aps',                    label: 'APS (atención primaria)' },
  { value: 'neonatologia_pediatria', label: 'Neonatología / Pediatría' },
  { value: 'otro',                   label: 'Otro servicio' },
];

export const UNIVERSIDADES_VALIDAS = UNIVERSIDAD_OPTIONS.map((o) => o.value);
export const SERVICIOS_VALIDOS = SERVICIO_OPTIONS.map((o) => o.value);

export const UNIVERSIDAD_LABEL = Object.fromEntries(UNIVERSIDAD_OPTIONS.map((o) => [o.value, o.label]));
export const SERVICIO_LABEL = Object.fromEntries(SERVICIO_OPTIONS.map((o) => [o.value, o.label]));

// A quién se le pregunta cada campo. La universidad solo tiene sentido para
// quien estudia la carrera; el servicio para quien ejerce (enfermero, TENS) y
// para el estudiante como lugar de práctica. Sin rol no se pregunta ninguna.
export function aplicaUniversidad(rol) {
  return rol === 'estudiante';
}

export function aplicaServicio(rol) {
  return rol === 'estudiante' || rol === 'enfermero' || rol === 'tens';
}

// ¿A quién se le pide el texto libre `institucion` (obligatorio)? Solo a quien
// ejerce: su hospital o clínica. Al estudiante ya no (A17, decisión del
// fundador 2026-10-04): su universidad es la lista de arriba, opcional, con su
// "Otra". Lo que un estudiante ya tenía guardado en `institucion` NO se borra
// ni se migra: simplemente no se le vuelve a pedir ni se reescribe al
// guardar. Fuente única de Perfil.jsx, OnboardingAgente.jsx y perfilListo.
export function aplicaInstitucion(rol) {
  return rol === 'enfermero' || rol === 'tens';
}

// El texto de la pregunta de servicio cambia con el rol; la respuesta, no.
export function labelServicio(rol) {
  return rol === 'estudiante' ? '¿Dónde haces práctica hoy?' : '¿En qué servicio trabajas?';
}

// Validación autoritativa del cliente (la BD tiene su CHECK como segundo
// candado): un valor fuera de catálogo o que no aplica al rol viaja como NULL,
// nunca como texto. Devuelve la fila lista para profiles.
export function normalizarPerfilEnriquecido({ rol, universidad, servicio } = {}) {
  return {
    universidad: aplicaUniversidad(rol) && UNIVERSIDADES_VALIDAS.includes(universidad) ? universidad : null,
    servicio: aplicaServicio(rol) && SERVICIOS_VALIDOS.includes(servicio) ? servicio : null,
  };
}
